<template>
<div
    class="assignment-edit"
    v-loading="!show"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading">
  <el-card class="head-tit" shadow="hover">
    任务详情
  </el-card>
  <editTaskInfo :taskEdit="taskEdit"></editTaskInfo>
  <!-- 商品列表信息 -->
  <el-card shadow="hover" class="assignmentedit-List" v-if="show">
    <label class="top-tit">商品信息</label>
    <div class="top-btn">
      <div>
        <el-button v-if="(taskEdit.status == 2 && natures === '2' && taskEdit.typeName!='拒收入库') || (taskEdit.status == 2 && natures === '3') " type="primary" @click="shopAdd">添加商品</el-button></div>
      <el-button type="text" class="handle-btn" @click="getTaskLog">操作记录</el-button>
    </div>
    <el-form :model="formInfo" :rules="rules" ref="goodsForm" class="goods-form">
      <el-table
        style="margin: 20px 0"
        :data=" taskEdit.status == 2 ? formInfo.goodsListAll : goodsListEdit"
        border>
        <el-table-column
          type="index"
          label="序号"
          align="center"
          width="100">
        </el-table-column>
        <el-table-column
          prop="name"
          label="商品名称"
          width="140"
          align="center">
        </el-table-column>
        <el-table-column
          prop="typeName"
          align="center"
          width="120"
          label="商品属性">
        </el-table-column>
        <el-table-column
          prop="standard"
          align="center"
          width="120"
          label="规格">
        </el-table-column>
        <el-table-column
          prop="box"
          align="center"
          width="130"
          label="箱规(件/箱)">
        </el-table-column>
        <el-table-column
          align="center"
          width="180"
          :label="'计划数量 \n (正常品)'">
          <template slot-scope="scope">
            <div>{{scope.row.num ? scope.row.num : '0'}}{{ scope.row.minUnitName }}</div>
            <div style="color: #808080">
              <label>({{scope.row.num ? parseInt(scope.row.num / scope.row.box): '0'}}{{ scope.row.maxUnitName }}</label>
              <label>{{scope.row.num ? scope.row.num % scope.row.box: '0'}}{{ scope.row.minUnitName }})</label>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-if="taskEdit.taskType === 'TASK_TYPE_EMPTY' ||  taskEdit.taskType === 'TASK_TYPE_OTHER_OUT'"
          align="center"
          width="180"
          :label="'计划数量 \n (破损品)'">
          <template v-if="taskEdit.taskType === 'TASK_TYPE_EMPTY'  ||  taskEdit.taskType === 'TASK_TYPE_OTHER_OUT'" slot-scope="scope">
            <div>{{scope.row.wornNum ? scope.row.wornNum : '0'}}{{ scope.row.minUnitName }}</div>
            <div style="color: #808080">
              <label>({{scope.row.wornNum ? parseInt(scope.row.wornNum / scope.row.box): '0'}}{{ scope.row.maxUnitName }}</label>
              <label>{{scope.row.wornNum ? scope.row.wornNum % scope.row.box: '0'}}{{ scope.row.minUnitName }})</label>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-if="taskEdit.status === 2"
          align="center"
          :label="'完成数量 \n (正常品)'"
          width="180">
          <template slot-scope="scope">
            <el-form-item :prop="'goodsListAll.' + scope.$index + '.actualNum'" :rules="rules.actualNum">
              <div style="display: flex;line-height: 32px;justify-content: center">
                <el-input-number size="small" v-model="scope.row.actualNum" :min="0" :max="xxx ? scope.row.lockAndUse : 99999999" :controls="false" :precision="0" >
                </el-input-number><label>{{ scope.row.minUnitName }}</label>
              </div>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
          v-if="taskEdit.status === 2 && (taskEdit.taskType !== 'TASK_TYPE_CPFR' && taskEdit.taskType !== 'TASK_TYPE_SEND')"
          align="center"
          :label="'完成数量 \n (破损品)'"
          width="180">
          <template slot-scope="scope" v-if="taskEdit.status === 2 && taskEdit.taskType !== 'TASK_TYPE_SEND'" >
            <el-form-item :prop="'goodsListAll.' + scope.$index + '.actualWornNum'" :rules="rules.actualWornNum">
              <div style="display: flex;line-height: 32px;justify-content: center">
                <el-input-number size="small" v-model="scope.row.actualWornNum" :min="0" :max="xxx ? scope.row.unLockAndUse : 99999999" :controls="false" :precision="0" >
                </el-input-number><label>{{ scope.row.minUnitName }}</label>
              </div>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
          prop="barCode"
          label="商品条码"
          width="200"
          align="center">
          <template slot-scope="scope">
            <label v-if="scope.row.barCode">{{scope.row.barCode}}</label>
            <label v-else>-</label>
          </template>
        </el-table-column>
        <el-table-column
          prop="goodsCode"
          label="商品编码"
          :width="taskEdit.status == 2 ? 200 : ''"
          align="center">
          <template slot-scope="scope">
            <label v-if="scope.row.goodsCode">{{scope.row.goodsCode}}</label>
            <label v-else>-</label>
          </template>
        </el-table-column>
        <el-table-column
          prop="supplier"
          align="center"
          :width="taskEdit.status == 2 ? 200 : ''"
          label="供应商">
          <template slot-scope="scope">
            <label v-if="scope.row.supplier">{{scope.row.supplier}}</label>
            <label v-else>-</label>
          </template>
        </el-table-column>
        <el-table-column
          v-if="taskEdit.status == 2"
          align="center"
          fixed="right"
          width="120"
          label="操作">
          <template slot-scope="scope">
            <div class="operation-warp">
              <div v-if="taskEdit.status == 2 && !scope.row.id" @click.prevent="detail(scope.$index)">删除</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <div class="btm-label">
      <label style="margin-left: auto;color: #808080;">计划总数：SKU种数{{this.taskEdit.skuNum}}，共{{this.taskEdit.num}}件</label>
      <label v-if="taskEdit.status == 2" style="margin-left: auto;color: #808080;padding:5px 0">
        完成总数：SKU种数{{formInfo.goodsListAll.length}}，共{{this.piece}}件</label>
    </div>
    <!-- 返回、取消、接单 -->
    <orderReceiving :code="code" :natures="natures" :taskEdit="taskEdit"></orderReceiving>
  </el-card>
  <!-- 单据上传 -->
  <el-card v-if="taskEdit.status == 2 && show && !saas" shadow="hover" class="assignmentedit-List">
    <label class="top-tit">单据上传</label>
    <upload-pic ref="upload" :fileIds="fileIds" :pictureList="pictureList" :limit="3" :isDisabled="false" :delet="true"></upload-pic>
    <label class="upload-text">建议＜3M，最多3张</label>
    <div class="btm-button">
      <el-button size="medium" @click="back">返 回</el-button>
      <el-button type="primary" @click="confirm" :disabled="isConfirmBtnDis">确认完成</el-button>
    </div>
  </el-card>
  <!-- 新增商品弹窗 -->
  <el-dialog
    :title="formDialog.title"
    :visible.sync="formDialog.visibel"
    width="60%"
    :before-close="handleClose">
    <div class="add-search">
      <el-input style="width: 200px !important" v-model="name" clearable placeholder="输入商品名称">
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <el-input style="width: 220px !important" v-model="goodsCode" clearable :placeholder="'输入商品编码或' + $idName()">
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <el-button type="primary" @click="search">查询</el-button>
    </div>
      <el-table
        ref="multipleTable"
        v-if="formDialog.visibel"
        border
        :data="assignmentEditAdding"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          :selectable="checkSelectable"
          align="center"
          width="80">
        </el-table-column>
        <el-table-column
          type="index"
          label="序号"
          align="center"
          width="90">
        </el-table-column>
        <el-table-column
          prop="name"
          label="商品名称"
          align="center"
          width="140">
        </el-table-column>
        <el-table-column
          prop="standard"
          label="规格"
          align="center">
        </el-table-column>
        <el-table-column
          prop="box"
          label="箱规(件/箱)"
          align="center">
        </el-table-column>
        <el-table-column
          v-if="userinfo.isMdOpen === 1"
          prop="box"
          label="保质期（天）"
          align="center">
        </el-table-column>
        <el-table-column
          prop="supplierCode"
          align="center"
          label="可用库存">
          <template slot-scope="scope">
            <div>
              {{scope.row.inventory}}{{ scope.row.minUnitName }}
            </div>
            <div style="color: #808080">
            <label>({{scope.row.supplierCode ? parseInt(scope.row.inventory / scope.row.box): '0'}}{{ scope.row.maxUnitName }}</label>
            <label>{{scope.row.supplierCode ? scope.row.inventory % scope.row.box: '0'}}{{ scope.row.minUnitName }})</label>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="supplierCode"
          align="center"
          label="不可用库存">
          <template slot-scope="scope">
            <div>
              {{scope.row.unavailable}}{{ scope.row.minUnitName }}
            </div>
            <div style="color: #808080">
            <label>({{scope.row.supplierCode ? parseInt(scope.row.unavailable / scope.row.box): '0'}}{{ scope.row.maxUnitName }}</label>
            <label>{{scope.row.supplierCode ? scope.row.unavailable % scope.row.box: '0'}}{{ scope.row.minUnitName }})</label>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="商品编码"
          prop="goodsCode"
          align="center"
          width="140">
        </el-table-column>
        <el-table-column
          prop="supplier"
          label="供应商"
          align="center">
          <template slot-scope="scope">
            <label v-if="scope.row.supplier">{{scope.row.supplier}}</label>
            <label v-else>-</label>
          </template>
        </el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button @click="formDialog.visibel = false">取 消</el-button>
      <el-button type="primary" @click="sureBtn">确 定</el-button>
    </span>
  </el-dialog>
  <!-- 确认完成弹窗 -->
  <el-dialog
    title="信息确认"
    :visible.sync="dialogVisible"
    width="30%"
     class="demo-ruleForm"
    :before-close="handleClose">
    <div class="btm-confirm">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item v-if="loading" label="装卸服务：" prop="loading">
          <el-radio v-model="form.loading" label="1">需要</el-radio>
          <el-radio v-model="form.loading" label="0">不需要</el-radio>
        </el-form-item>
        <el-form-item v-if="plate" label="配送板数：" prop="plate">
          <el-input maxlength="5" v-model="form.plate">
            <template slot="append">板</template>
          </el-input><br/>
          系统计算值:{{plateNum}}板
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer" style="text-align: center;">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="sumbit('form')" :disabled="isSaveBtnDis">保 存</el-button>
    </span>
  </el-dialog>
  <task-log :taskLogVisible.sync='taskLogVisible' :taskLogList='taskLogList' @closeDialog="closeDialog"></task-log>
</div>
</template>

<script>
import assignmentManage from '@/store/assignmentManage/index'
import {GETTASKDETAILS, COMPLETETASK, TASKGETGOODTSS, COUNTPLATENUM, GETTASKLOGLIST} from '@/store/assignmentManage/types'
import {GETUNPRODUCTDATEDETAILLIST} from '@/store/rollsHomework/types'
import {CLOSECURRENTTAG} from '@/store/user/types'
import UploadPic from '../components/uploadImage'
import editTaskInfo from '../components/editTaskInfo'
import orderReceiving from '../components/orderReceiving'
import user from '@/store/user/index'
import taskLog from '../components/taskLog'
export default {
  name: 'assignmentEdit',
  props: [],
  data () {
    return {
      rules: {
        actualNum: [{ validator: (rule, value, callback) => this.validateCompletedNum(rule, value, callback, 'actualNum'), trigger: 'blur' }],
        actualWornNum: [{ validator: (rule, value, callback) => this.validateCompletedNum(rule, value, callback, 'actualWornNum'), trigger: 'blur' }],
        loading: [{ required: true, message: '请选择装卸服务', trigger: 'change' }],
        plate: [{ required: true, trigger: 'blur', validator: this.validateNum }]
      },
      pictureList: [],
      paramArr: {
        dbInfo: []
      },
      fileIds: [],
      show: false, // 加载
      loading: false, // 是否装卸
      plate: false, // 是否配送板数
      name: '', // 商品名字筛选
      goodsCode: '', // 商品code筛选
      natures: '', // 商品性质
      code: '', // 商品code
      type: '', // 任务类型
      addGoodsList: [], // 新增的商品列表
      selectGoodsList: [], // 新选择商品列表
      goodsList: [], // 原有的商品列表
      oldGoodsCode: [], // 原有商品code
      formInfo: {
        goodsListAll: [] // 商品总列表
      },
      skusum: 0, // sku总数
      piece: 0, // 实际总件数
      flag: true, // 提交标识
      dialogVisible: false,
      // dialog配置
      formDialog: {
        title: '添加商品',
        visibel: false
      },
      // 信息确认弹窗
      form: {
        loading: '',
        plate: ''
      },
      isSaveBtnDis: false,
      taskLogVisible: false,
      saas: '',
      warehouseCode: ''
    }
  },
  components: {
    UploadPic, editTaskInfo, orderReceiving, taskLog
  },
  computed: {
    plateNum () {
      return assignmentManage.state.plateNum
    },
    // 任务详情数据
    taskEdit () {
      return assignmentManage.state.taskEdit
    },
    // 列表数据
    goodsListEdit: {
      get () {
        return assignmentManage.state.goodsListEdit
      },
      set (val) {
        this.$store.state.assignmentManage.goodsListEdit = val
      }
    },
    // 标识
    assigneditMark () {
      return assignmentManage.state.assigneditMark
    },
    // 新增商品列表
    assignmentEditAdding () {
      return assignmentManage.state.assignmentEditAdding
    },
    upload () {
      return this.$refs.upload
    },
    taskPrintBillEditCode () {
      return assignmentManage.state.taskPrintBillEditCode
    },
    taskPrintBillGoodList () {
      return assignmentManage.state.taskPrintBillGoodList
    },
    xxx () {
      let flag = false
      if (this.taskEdit.typeName !== '多余退货' && this.taskEdit.typeName !== '售后退货' && this.taskEdit.typeName !== '到货' && this.taskEdit.typeName !== '拒收入库' && this.taskEdit.typeName !== '其他入库') {
        flag = true
      }
      return flag
    },
    // 是否禁用确认完成按钮
    isConfirmBtnDis () {
      return assignmentManage.state.isConfirmBtnDis
    },
    userinfo () {
      return user.state.userinfo
    },
    // 是否跳转生产日期录入（入库任务并且当前仓库的商品生产日期开关打开）
    isToDateManufacture () {
      let warehouseCodes = JSON.parse(localStorage.getItem('warehouseCodes'))
      let result = warehouseCodes.find(item => item.value === this.$route.params.warehouseCode)
      return this.natures === '2' && result.isMdOpen === 1
    },
    // 操作记录
    taskLogList () {
      return assignmentManage.state.taskLogList
    }
  },
  created () {
    this.warehouseCode = this.$route.params.warehouseCode
    if (this.$route.params.nature === '2') this.$route.meta.title = '入库-编辑'
    this.code = this.$route.params.code
    this.natures = this.$route.params.nature
    this.show = false
    this.getList()
    this.getGoods()
    setTimeout(() => {
      this.show = true
    }, 500)
  },
  watch: {
    // 标识监听
    assigneditMark: {
      deep: true,
      handler (val) {
        console.log({val})
        // eslint-disable-next-line eqeqeq
        if (val == 1) {
          assignmentManage.state.assigneditMark = 0
          // eslint-disable-next-line eqeqeq
          if (this.nature == '1') {
            this.$store.dispatch('tagsView/setBeforePageName', 'warehouseout')
            this.$store.dispatch(CLOSECURRENTTAG, '/assignmentmanage/warehouseout')
          } else {
            this.$store.dispatch('tagsView/setBeforePageName', 'warehouseinto')
            this.$store.dispatch(CLOSECURRENTTAG, '/assignmentmanage/warehouseinto')
          }
          // eslint-disable-next-line eqeqeq
        } else if (val == 2) {
          assignmentManage.state.assigneditMark = 0
          this.show = false
          this.getList()
          setTimeout(() => {
            this.show = true
          }, 500)
        }
      }
    },
    // 判断进行中/未接单
    taskEdit: {
      deep: true,
      handler (val) {
        this.getGoods()
        if (val.loading === 1) {
          this.form.loading = '1'
        } else {
          this.form.loading = '0'
        }
      }
    },
    // 原商品数据
    goodsListEdit: {
      deep: true,
      handler (val) {
        if (val) {
          let sum = 0
          // 获取原数据goodsCode
          this.oldGoodsCode = val.map(ele => ele.goodsCode)
          if (this.taskEdit.status === 2) {
            if (this.taskPrintBillEditCode) {
              this.formInfo.goodsListAll = [...this.taskPrintBillGoodList]
              assignmentManage.state.taskPrintBillEditCode = null
            } else {
              this.formInfo.goodsListAll = [...val]
            }
          }
          // 计算当前价格
          val.forEach((item) => {
            sum += item.actualNum
            sum += item.actualWornNum
          })
          this.piece = sum
        }
      }
    }
  },
  mounted () {
    this.code = this.$route.params.code
    this.natures = this.$route.params.nature
    this.type = this.$route.params.taskType
    if (this.userinfo.identity === 3) {
      this.saas = '1'
    }
    // 获取编辑回显数据
    setTimeout(() => {
      this.show = true
    }, 500)
  },
  methods: {
    // 获取编辑回显数据
    getList () {
      let params = {
        code: this.code
      }
      this.$store.dispatch(GETTASKDETAILS, params)
    },
    // 获取新增商品列表
    getGoods () {
      let params = {
        supplierCode: this.taskEdit.supplierCode,
        name: this.name,
        type: this.type,
        goodsCode: this.goodsCode,
        warehouseCode: this.warehouseCode
      }
      this.$store.dispatch(TASKGETGOODTSS, params)
    },
    // 新增商品
    shopAdd () {
      this.formDialog.visibel = true
      this.$nextTick(() => {
        this.cehckedReset()
      })
    },
    // 查询
    search () {
      this.getGoods()
      setTimeout(() => {
        this.cehckedReset()
      }, 200)
    },
    // 确认新增商品
    sureBtn () {
      this.deteleObject(this.assignmentEditAdding, this.selectGoodsList)
      setTimeout(() => {
        this.handleChange()
      }, 50)
      this.formDialog.visibel = false
    },
    // 确认完成
    confirm () {
      let flag = true
      this.$refs.goodsForm.validate((valid) => {
        if (!valid) flag = false
      })
      if (!flag) return false

      this.flag = true
      if (Number(this.natures) === 1) {
        this.checkData()
      } else {
        let arr = []
        let all = [...this.formInfo.goodsListAll]
        all.forEach((item, index) => {
          arr.push({
            id: item.id,
            actualNum: item.actualNum ? item.actualNum : 0,
            actualWornNum: item.actualWornNum ? item.actualWornNum : 0,
            ddId: item.ddId,
            goodsCode: item.goodsCode
          })
        })
        this.filterData(arr)
      }
      let allgood = [...this.formInfo.goodsListAll]
      this.paramArr.dbInfo = []
      let that = this
      allgood.forEach(item => {
        let normal = item.actualNum ? item.actualNum : 0
        let worn = item.actualWornNum ? item.actualWornNum : 0
        that.paramArr.dbInfo.push({
          goodCode: item.goodsCode,
          goodNum: normal + worn
        })
      })

      if (this.flag) {
        if ((this.taskEdit.taskType === 'TASK_TYPE_SEND' && this.taskEdit.isBoard) ||
         (this.taskEdit.taskType === 'TASK_TYPE_REMAINING' && this.taskEdit.isBoard) ||
          (this.taskEdit.taskType === 'TASK_TYPE_AFTER' && this.taskEdit.isBoard) ||
          (this.taskEdit.taskType === 'TASK_TYPE_CPFR' && this.taskEdit.isBoard)) {
          this.$store.dispatch(COUNTPLATENUM, JSON.stringify(this.paramArr)).then(() => {
            this.dialogVisible = true
            this.plate = true
          })
        } else if (this.taskEdit.taskType === 'TASK_TYPE_ARRIVE' ||
         this.taskEdit.taskType === 'TASK_TYPE_EMPTY' || this.taskEdit.taskType === 'TASK_TYPE_OTHER_PUT' || this.taskEdit.taskType === 'TASK_TYPE_OTHER_OUT') {
          this.loading = true
          this.dialogVisible = true
        } else {
          this.isSaveBtnDis = true
          let data = this.taskEdit
          let task = {
            code: data.code,
            status: 3,
            urls: this.fileIds.join(',')
          }
          let params = {
            task: task,
            goodsList: this.goodsList,
            addGoodsList: this.addGoodsList
          }
          this.$store.dispatch(COMPLETETASK, JSON.stringify(params)).then(res => {
            if (res.success) {
              if (this.isToDateManufacture) {
                return this.checkToDateManufacture('toBack')
              }
              this.back()
            }
          })
        }
      }
    },
    // 信息确认提交
    sumbit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.goodsList.forEach(item => {
            if (item.actualWornNum > item.unLockAndUse) {
              this.$message.error('不可用库存（破损品）不能超过可用最大库存为（破损品）')
              return null
            }
          })
          let data = this.taskEdit
          let task = {
            code: data.code,
            status: 3,
            urls: this.fileIds.join(',')
          }
          if (this.plate) {
            task.plate = Number(this.form.plate)
            task.relPlate = Number(this.plateNum)
          } else if (this.loading) {
            task.loading = Number(this.form.loading)
          }

          let params = {
            task: task,
            goodsList: this.goodsList,
            addGoodsList: this.addGoodsList
          }
          this.$store.dispatch(COMPLETETASK, JSON.stringify(params)).then(res => {
            if (res.success) {
              if (this.isToDateManufacture) {
                return this.checkToDateManufacture('toBack')
              }
              this.back()
            }
          })
        } else {
          return false
        }
      })
    },
    // 返回
    back () {
      // if (this.natures === '2') {
      //   return this.$router.push('/assignmentmanage/warehouseinto')
      // }
      // this.$router.push('/assignmentmanage/warehouseout')
      assignmentManage.state.assigneditMark = 1
    },
    // 删除
    detail (index) {
      this.formInfo.goodsListAll[index].actualNum = 0
      this.formInfo.goodsListAll[index].actualWornNum = 0
      setTimeout(() => {
        this.formInfo.goodsListAll.splice(index, 1)
        this.goodsListEdit.splice(index, 1)
      }, 50)
      this.selectGoodsList.splice(index, 1)
      this.oldGoodsCode.splice(index, 1)

      this.handleChange()
    },
    // 新增商品列表select选择
    handleSelectionChange (val) {
      val.forEach((item) => {
        item.actualNum = item.actualNum ? item.actualNum : 0
      })
      this.selectGoodsList = val.map(item => item.goodsCode)
    },
    // 原商品禁用选择
    checkSelectable (row) {
      return this.oldGoodsCode.indexOf(row.goodsCode) === -1
    },
    // 监听箱、件变化
    handleChange (row) {
      let piece = 0
      this.formInfo.goodsListAll.forEach(item => {
        piece += Number(item.actualNum)
        piece += Number(item.actualWornNum)
      })
      this.piece = piece

      if (this.taskEdit.taskType === 'TASK_TYPE_EMPTY' || this.taskEdit.taskType === 'TASK_TYPE_OTHER_OUT') {
        if (row !== undefined) {
          if (row.actualWornNum > row.unLockAndUse) {
            this.$message.error('可用最大库存为' + row.unLockAndUse + '（破损品）')
            row.actualWornNum = row.unLockAndUse
          }
        }
      }
    },
    // 重新判断商品是否选中
    cehckedReset () {
      if (this.formInfo.goodsListAll) {
        this.formInfo.goodsListAll.forEach((item, index) => {
          this.assignmentEditAdding.forEach((add, id) => {
            if (add.goodsCode === item.goodsCode) {
              this.$refs.multipleTable.toggleRowSelection(this.assignmentEditAdding[id])
            }
          })
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    // 过滤新增、旧数组 --- 用于上传
    filterData (arr) {
      this.addGoodsList = arr.filter((item) =>
        !item.id
      )
      this.goodsList = arr.filter((item) =>
        item.id
      )
    },
    // 数据校验
    checkData () {
      let arr = []
      this.formInfo.goodsListAll.forEach((item, index) => {
        // item.actualNum = item.boxs * item.box + item.piece
        if (item.actualNum > item.num + item.inventory) {
          this.$confirm(item.name + '超出数量上限', '确认失败', {
            confirmButtonText: '确定',
            showCancelButton: false,
            type: 'error'
          })
          this.flag = false
        } else {
          arr.push({
            id: item.id,
            actualNum: item.actualNum ? item.actualNum : 0,
            actualWornNum: item.actualWornNum ? item.actualWornNum : 0,
            ddId: item.ddId,
            goodsCode: item.goodsCode
          })
        }
      })
      this.filterData(arr)
    },
    // 商品数组对象过滤
    deteleObject (arr1, arr2) {
      arr1.forEach(item => {
        if (arr2.indexOf(item.goodsCode) !== -1) {
          // 新增
          let flag = true
          this.formInfo.goodsListAll.forEach((ele) => {
            if (ele.goodsCode === item.goodsCode) {
              flag = false
            }
          })
          if (flag) {
            item.actualNum = 0
            this.goodsListEdit.push(item)
            this.formInfo.goodsListAll.push(item)
          }
        } else {
          // 移除
          this.formInfo.goodsListAll = this.formInfo.goodsListAll.filter((ele) => {
            return ele.goodsCode !== item.goodsCode
          })
          this.goodsListEdit = this.goodsListEdit.filter((ele) => {
            return ele.goodsCode !== item.goodsCode
          })
        }
      })
    },
    // 校验是否需要跳转生产日期录入接口
    checkToDateManufacture (type) {
      let warehouseCode = this.$route.params.warehouseCode
      let params = {
        taskCode: this.code
      }
      this.$store.dispatch(GETUNPRODUCTDATEDETAILLIST, params).then(res => {
        if (res.obj.length > 0) {
          this.$store.dispatch('tagsView/delView', this.$route)
          return this.$router.push(`/rollsHomework/productionDateEntry/productionDateEntryDetail/${this.code}/0/` + warehouseCode)
        }
        switch (type) {
          case 'toList':
            this.$store.dispatch(CLOSECURRENTTAG, '/assignmentmanage/assignmentmanage')
            break
          case 'toBack':
            this.back()
            break
        }
      })
    },
    // 关闭弹窗
    handleClose () {
      this.formDialog.visibel = false
      this.dialogVisible = false
      if (this.$refs['form']) {
        this.$refs['form'].clearValidate()
      }
      if (this.taskEdit.loading === 1) {
        this.form.loading = '1'
      } else {
        this.form.loading = '0'
      }
    },
    // 正整数校验
    validateNum (rule, value, callback) {
      if (value !== '') {
        if (Number.isInteger(Number(value)) && Number(value) >= 0 && String(value).indexOf('.') < 0) {
          callback()
        } else {
          callback(new Error('请输入不小于0的正整数'))
        }
      } else {
        callback(new Error('请输入配送板数'))
      }
    },
    // 校验完成数量
    validateCompletedNum (rule, value, callback, goodsType) {
      let index = rule.fullField.split('.')[1]
      let goods = this.formInfo.goodsListAll[index]
      // 入库任务 和 编辑页新增的商品不需要校验
      if ((this.natures === '2' || goodsType === 'actualWornNum') || !goods.id) return callback()
      let type = {
        name: goodsType === 'actualNum' ? '正常品' : '破损品',
        key1: goodsType === 'actualNum' ? 'num' : 'wornNum',
        key2: goodsType === 'actualNum' ? 'inventory' : 'unavailable'
      }
      if (value > (goods[type.key1] + goods[type.key2])) {
        callback(new Error(`不能大于计划数量${type.name}`))
      }
      callback()
    },
    // 查看操作记录
    getTaskLog () {
      let params = {
        code: this.code
      }
      this.$store.dispatch(GETTASKLOGLIST, params)
      this.taskLogVisible = true
    },
    // 关闭操作记录窗口
    closeDialog (val) {
      this.taskLogVisible = val
    }
  }
}
</script>
<style>
.top-btn{
  display: flex;
  justify-content:space-between
}

</style>
<style scoped>
.handle-btn{
  width:120px;
}
  .top-warp {
    padding-left: 20px;
  }
  .top-tit{
    font-size: 20px;
    padding-bottom: 30px;
    display: flex;
    font-weight: bold;
    color: #696969;
  }
  .top-code {
    font-size: 18px;
    line-height: 31px;
    height: 30px;
    overflow: hidden;
  }
  .assignmentedit-List {
    padding-left: 20px;
    position: relative;
  }
  .assignment-content {
    flex-direction: column;
    display: flex;
  }
  .assignment-content label {
    padding: 5px 0;
  }
  .btm-button {
    width: 58%;
    margin-left: auto;
    padding-top: 20px;
  }
  .operation-warp {
    display: flex;
    align-items: center;
    justify-content: space-around;
    color: #409EFF;
    cursor: pointer;
  }
  .operation-warp div:hover {
    color: #66b1ff;
  }
  .add-search {
    display: flex;
    width: 48%;
    justify-content: space-between;
    padding-bottom: 20px;
  }
  .btm-label {
    display: flex;
    flex-direction: column;
  }
  .btm-confirm {
    width: 80%;
    margin: 0 auto;
    overflow: hidden;
  }
  .demo-ruleForm >>> .el-dialog__body {
    height: auto !important;
  }
  .assignmentedit-List >>> .el-table .cell{
    white-space:pre-line;
  }
  .upload-text {
    color: #444;
    opacity: 0.9;
    font-family: sans-serif;
    font-size: 15px;
  }
  .goods-form /deep/ .el-form-item {
    margin-top: 10px;
  }
  .goods-form /deep/ .el-form-item__error {
    line-height: 0.5;
  }

</style>



// WEBPACK FOOTER //
// src/page/assignmentManage/warehouse/WarehouseIntoEdit.vue